export interface CaseItem {
  id: number;
  slug: string;
  company: string;
  shortName: string;
  industry: string;
  project: string;
  summary: string;
  heroImage: string;
  cardImage: string;
  logoText?: string;
  companyDesc: string;
  stats: {
    label: string;
    value: string;
    sub?: string;
  }[];
  demands: string[];
  painPoints: string;
  solutionTitle: string;
  solutionDesc: string;
  solutionFeatures: string[];
  solutionArchitecture?: {
    title: string;
    steps: { name: string; desc: string; highlight?: boolean }[];
  };
  valueTitle?: string;
  valueItems?: string[];
  schemeTitle: string;
  schemeDesc: string;
  schemeNote?: string;
}

export const casesList = [
  {
    id: 1,
    slug: 'zhongyifeng-holding',
    company: '中亿丰控股',
    shortName: 'ZYF 中亿丰',
    industry: '建筑领域',
    project: '网银智能体项目',
    summary: '通过引入USBServer + AI智能体，实现数十家银行近千个U盾的自动调度与自动制单，大幅提升支付管控和资金运营效率。',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20construction%20corporate%20office%20building%20exterior%2C%20clean%20geometric%20architectural%20lines%2C%20dark%20blue%20and%20gray%20professional%20atmosphere%2C%20minimal%20corporate%20technology%20aesthetic%2C%20wide%20banner%20composition%2C%20no%20glowing%20effects&width=1600&height=700&seq=case-hero-zhongyifeng&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20construction%20group%20headquarters%20building%2C%20clean%20geometric%20architecture%2C%20dark%20moody%20professional%20atmosphere%2C%20minimal%20elegant%20corporate%20photography%2C%20no%20glowing%20effects%20no%20neon&width=600&height=400&seq=case-card-zhongyifeng&orientation=landscape',
  },
  {
    id: 2,
    slug: 'luopsijin-aluminum',
    company: '罗普斯金铝业',
    shortName: 'LPS 罗普斯金铝业',
    industry: '铝型材/系统门窗',
    project: '网银智能体项目',
    summary: '通过引入USBServer + AI网银智能体，构建网银U盾集中管理与自动化下载平台，实现资金数据从银行端到业务系统的自动采集与归档。',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20aluminum%20manufacturing%20facility%2C%20clean%20geometric%20factory%20architecture%2C%20dark%20blue%20and%20warm%20amber%20professional%20atmosphere%2C%20minimal%20corporate%20technology%20aesthetic%2C%20wide%20banner%20composition%2C%20no%20glowing%20effects&width=1600&height=700&seq=case-hero-luopsijin&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20aluminum%20extrusion%20industrial%20plant%20exterior%2C%20clean%20geometric%20industrial%20architecture%2C%20dark%20moody%20professional%20atmosphere%2C%20minimal%20elegant%20corporate%20photography%2C%20no%20glowing%20effects%20no%20neon&width=600&height=400&seq=case-card-luopsijin&orientation=landscape',
  },
];

export const caseDetails: Record<string, CaseItem> = {
  'zhongyifeng-holding': {
    id: 1,
    slug: 'zhongyifeng-holding',
    company: '中亿丰控股',
    shortName: 'ZYF 中亿丰',
    industry: '建筑领域',
    project: '网银智能体项目',
    summary: '通过引入USBServer + AI智能体，实现数十家银行近千个U盾的自动调度与自动制单，大幅提升支付管控和资金运营效率。',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20construction%20corporate%20office%20building%20exterior%2C%20clean%20geometric%20architectural%20lines%2C%20dark%20blue%20and%20gray%20professional%20atmosphere%2C%20minimal%20corporate%20technology%20aesthetic%2C%20wide%20banner%20composition%2C%20no%20glowing%20effects&width=1600&height=700&seq=case-hero-zhongyifeng&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20construction%20group%20headquarters%20building%2C%20clean%20geometric%20architecture%2C%20dark%20moody%20professional%20atmosphere%2C%20minimal%20elegant%20corporate%20photography%2C%20no%20glowing%20effects%20no%20neon&width=600&height=400&seq=case-card-zhongyifeng&orientation=landscape',
    logoText: 'ZYF',
    companyDesc:
      '中亿丰控股集团有限公司前身为2011年11月成立的苏州中恒投资有限公司，2025年3月注册资本由9.898亿元增至9.91亿元。该公司以建筑领域为核心，通过控股子公司中亿丰建设集团股份有限公司开展投资并购整合。2023年营业收入为385.84亿元，2025年以401.7796亿元营业额位列中国民营企业500强第314位。',
    stats: [
      { label: '财务部', value: '20人' },
      { label: 'U盾数量', value: '780个' },
      { label: '银行数', value: '28家' },
      { label: '账号数量', value: '850个' },
    ],
    demands: [
      '流水下载',
      '回单下载',
      '余额查询并录入金蝶EAS',
      '流水上传中台',
      '回单上传文档云',
    ],
    painPoints:
      '近年来，随着业务规模的增加，中亿丰控股的项目账户数量、项目U盾数量、业务交易金额和笔数不断攀升，日网银录入峰值达近万笔，涉及账户近千个，对支付效率和业务管理带来极大难题，资金的闭环管理和运营也受到较大阻碍，无法得到高效管理和资金运营能力的提升。',
    solutionTitle: '解决方案',
    solutionDesc:
      '通过引入USBServer + AI智能体，实现了U盾集中管理设作为硬件支撑，结合AI智能体对U盾的自动调度，实现AI智能体自动制单，实现了数十家银行的近千个U盾对应的银行账户实现自动制单、人工复核、交易结果同步的闭环流程，实现了高效的支付管控和资金闭环管理，制单效率和资金运营效率得到极大提升。',
    solutionFeatures: [
      'U盾集中管理作为硬件支撑',
      'AI智能体对U盾自动调度',
      'AI智能体自动制单',
      '自动制单 + 人工复核 + 交易结果同步闭环',
    ],
    schemeTitle: '软硬件一体化方案「网银智能体」',
    schemeDesc:
      '解决U盾集中管理与跨区域调用难题，提升工作效率。实现人和AI智能体分时共享同一个U盾资源、跨区域协同基础设施。',
    schemeNote: '实现人和AI智能体分时共享同一个U盾资源、跨区域协同基础设施。',
  },
  'luopsijin-aluminum': {
    id: 2,
    slug: 'luopsijin-aluminum',
    company: '罗普斯金铝业',
    shortName: 'LPS 罗普斯金铝业',
    industry: '铝型材/系统门窗',
    project: '网银智能体项目',
    summary: '通过引入USBServer + AI网银智能体，构建网银U盾集中管理与自动化下载平台，实现资金数据从银行端到业务系统的自动采集与归档。',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20aluminum%20manufacturing%20facility%2C%20clean%20geometric%20factory%20architecture%2C%20dark%20blue%20and%20warm%20amber%20professional%20atmosphere%2C%20minimal%20corporate%20technology%20aesthetic%2C%20wide%20banner%20composition%2C%20no%20glowing%20effects&width=1600&height=700&seq=case-hero-luopsijin&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20aluminum%20extrusion%20industrial%20plant%20exterior%2C%20clean%20geometric%20industrial%20architecture%2C%20dark%20moody%20professional%20atmosphere%2C%20minimal%20elegant%20corporate%20photography%2C%20no%20glowing%20effects%20no%20neon&width=600&height=400&seq=case-card-luopsijin&orientation=landscape',
    logoText: 'LPS',
    companyDesc:
      '罗普斯金铝业围绕铝型材、系统门窗及相关产业布局，业务覆盖制造、销售、工程项目及集团化财务管理场景。随着经营规模扩大，成员单位、银行账户和项目资金往来持续增加，对网银U盾、流水回单、余额查询和资金数据归集提出更高要求。',
    stats: [
      { label: '财务部', value: '10+人' },
      { label: 'U盾数量', value: '200+个' },
      { label: '银行数', value: '10+家' },
      { label: '账号数量', value: '250+个' },
    ],
    demands: [
      '银行U盾集中管理',
      '流水与回单批量下载',
      '账户余额自动查询',
      '对接ERP/资金系统',
      '资金日报表',
    ],
    painPoints:
      '随着经营规模扩大，成员单位、银行账户和项目资金往来持续增加，对网银U盾、流水回单、余额查询和资金数据归集提出更高要求。传统人工操作模式已无法满足日益增长的业务需求，亟需通过智能化手段提升业务管理的自动化水平和数据归集效率。',
    solutionTitle: '解决方案',
    solutionDesc:
      '通过引入USBServer + AI网银智能体，构建网银U盾集中管理与自动化下载平台。U盾统一接入集中柜，按角色、账号和流程进行授权调度，减少人工接触和跨区域占用。AI智能体自动登录网银，执行流水、回单、余额等数据下载，并将结果归档、校验、同步至ERP/资金系统。',
    solutionFeatures: [
      '网银U盾集中管理与自动化下载平台',
      'U盾统一接入集中柜，按角色和流程授权调度',
      'AI智能体自动登录网银，执行数据下载',
      '结果归档、校验、同步至ERP/资金系统',
    ],
    schemeTitle: '软硬件一体化方案：网银智能体',
    schemeDesc:
      '集中托管 + 智能调度 + 自动下载 + 审计留痕。实现资金数据从银行端到业务系统的自动采集、集中归档和可追溯管理。',
    valueTitle: '项目价值',
    valueItems: [
      '200多个网银账户数据每日自动下载',
      '流水与回单自动匹配',
      '流水传送ERP系统自动生成财务单据',
      'T+1资金日报表',
    ],
    schemeNote: '实现资金数据从银行端到业务系统的自动采集、集中归档和可追溯管理。',
  },
};